/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const arbitrum_chain_about = () => `Arbitrum serves as a Layer 2 scaling solution for Ethereum, leveraging rollups to significantly boost scalability and reduce transaction costs while maintaining robust security. It enables developers to execute EVM-compatible smart contracts with a substantially higher transaction throughput and lower fees compared to Ethereum's main chain, making it a compelling platform for decentralized application development.`
